import { render, staticRenderFns } from "./VuesticConnectionErrorLargeText.vue?vue&type=template&id=72da80fc&"
import script from "./VuesticConnectionErrorLargeText.vue?vue&type=script&lang=js&"
export * from "./VuesticConnectionErrorLargeText.vue?vue&type=script&lang=js&"
import style0 from "./VuesticConnectionErrorLargeText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports